import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import admindata from "../../components/admindata";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const $ = require("jquery");
$.Datatable = require("datatables.net");

const TempPending = () => {
  const history = useHistory();
  const [user, setUser] = useState();
  const [allDeposite, SetallDeposite] = useState();
  const [utrValue, setUtrValue] = useState("");
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }

  //use for pagination..
  let [limit, setLimit] = useState(10);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState(0);
  const [findByStatus, setFindByStatus] = useState(0);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;

    setSearchList(key);
  };
  //   search by status handler
  const searchByStatus = (event) => {
    let key = event.target.value;
    setFindByStatus(key);
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setPageNumber(currentPage);
    // scroll to the top
    //window.scrollTo(0, 0)
  };

  const profle = () => {
    const access_token = localStorage.getItem("cejoraTokenDash");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .get(
        baseUrl +
          `txn-temp-pending?page=${pageNumber}&_limit=${limit}&_q=${searchList}&_stype=${searchType}&_status=${findByStatus}&_startDate=${new Date(
            startDate,
          )}&_endDate=${new Date(endDate)}`,
        { headers },
      )
      .then((res) => {
        setUser(res.data.admin);
        setNumberOfPages(res.data.totalPages);
        //$('table').dataTable();
      });
  };

  const universalCheckDeposit = (
    payment_gatway,
    order_id,
    order_token,
    pay_date,
  ) => {
    alert(payment_gatway);
    if (payment_gatway == "cupi") {
      cowPayDepositCheck(order_id, order_token, pay_date);
    } else if (payment_gatway == "upi") {
      upiDepositCheck(order_id, order_token, pay_date);
    } else if (payment_gatway == "payin_upi") {
      f2pDepositCheck(order_id, order_token, pay_date);
    } else if (payment_gatway == "slikpay") {
      SilkPayDepositCheck(order_id, order_token, pay_date);
    } else if (payment_gatway == "utr-check-slikpay") {
      UtrCheckSilkPayDepositCheck(order_id, order_token, pay_date);
    } else if (payment_gatway == "utr-final-check-slikpay") {
      UtrCheckFinalSilkPayDepositCheck(order_id, order_token, pay_date);
    } else {
      alert("Nothing found");
    }
  };

  const cowPayDepositCheck = (orderID, order_token) => {
    const access_token = localStorage.getItem("cejoraTokenDash");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `manual-check-payin`,
        { orderID, order_token },
        { headers },
      )
      .then((res) => {
        if (res.data.status === true) {
          Swal.fire({
            title: res.data.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
          profle();
        } else {
          Swal.fire({
            title: res.data.msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("cejoraTokenDash");
          localStorage.removeItem("cejoraTokenDash");
          window.location.reload();
        }
      });
  };

  const f2pDepositCheck = (orderID, order_token) => {
    const access_token = localStorage.getItem("cejoraTokenDash");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `payin-check-query`,
        { orderID, order_token },
        { headers },
      )
      .then((res) => {
        if (res.data.status === true) {
          Swal.fire({
            title: res.data.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
          profle();
        } else {
          Swal.fire({
            title: `${res.data.msg} / ${res.data?.check}`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("cejoraTokenDash");
          localStorage.removeItem("cejoraTokenDash");
          window.location.reload();
        }
      });
  };

  const upiDepositCheck = (orderID, order_token) => {
    const access_token = localStorage.getItem("cejoraTokenDash");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `manual-upi-checkpaying`,
        { orderID, order_token },
        { headers },
      )
      .then((res) => {
        if (res.data.status === true) {
          Swal.fire({
            title: res.data.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
          profle();
        } else {
          Swal.fire({
            title: `${res.data.msg} / ${res.data?.check}`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("cejoraTokenDash");
          localStorage.removeItem("cejoraTokenDash");
          window.location.reload();
        }
      });
  };

  const UtrCheckSilkPayDepositCheck = (orderID, order_token) => {
    const access_token = localStorage.getItem("cejoraTokenDash");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `silkpay-utr-check`,
        { orderID, order_token },
        { headers },
      )
      .then((res) => {
        if (res.data.status === true) {
          Swal.fire({
            title: `${res.data.data.message}`,
            icon: "success",
            html: `
    <p><b>Message:</b> ${res.data.data.msg}</p>
    <p><b>Amount:</b> ₹${res.data.data.amount}</p>
    <p><b>Order ID:</b> ${res.data.data.mOrderId ?? "N/A"}</p>
  `,
            confirmButtonText: "OK",
          });
          profle();
        } else {
          Swal.fire({
            title: `${res.data.msg} / ${res.data?.check}`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("cejoraTokenDash");
          localStorage.removeItem("cejoraTokenDash");
          window.location.reload();
        }
      });
  };

  const UtrCheckFinalSilkPayDepositCheck = (orderID, order_token) => {
    const access_token = localStorage.getItem("cejoraTokenDash");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `silkpay-final-utr-check`,
        { orderID, order_token },
        { headers },
      )
      .then((res) => {
        if (res.data.status === true) {
          Swal.fire({
            title: `${res.data.data.message}`,
            icon: "success",
            html: `
    <p><b>orderStatus:</b> ${res.data.data?.data?.orderStatus}</p>
    <p><b>Amount:</b> ₹${res.data.data?.data?.amount}</p>
    <p><b>Order ID:</b> ${res.data.data?.data?.mOrderId ?? "N/A"}</p>
    <p><b>msg:</b> ${res.data.data?.data?.msg ?? "N/A"}</p>
  `,
            confirmButtonText: "OK",
          });
          profle();
        } else {
          Swal.fire({
            title: `${res.data.msg} / ${res.data?.check}`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("cejoraTokenDash");
          localStorage.removeItem("cejoraTokenDash");
          window.location.reload();
        }
      });
  };

  const SilkPayDepositCheck = (orderID, order_token) => {
    const access_token = localStorage.getItem("cejoraTokenDash");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `check-payin-request-slikpay`,
        { orderID, order_token },
        { headers },
      )
      .then((res) => {
        if (res.data.status === true) {
          Swal.fire({
            title: res.data.msg,
            icon: "success",
            confirmButtonText: "OK",
          });
          profle();
        } else {
          Swal.fire({
            title: `${res.data.msg} / ${res.data?.check}`,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((e) => {
        if (e.response.status == 401) {
          localStorage.removeItem("cejoraTokenDash");
          localStorage.removeItem("cejoraTokenDash");
          window.location.reload();
        }
      });
  };

  // check in

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour12: true,
      minute: "numeric",
    });
    return newDate;
  };

  const newdateFormat = (e) => {
    let today = new Date(e);
    let dd = String(today.getDate()).padStart(2, "0");
    let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    let yyyy = today.getFullYear();
    today = dd + "-" + mm + "-" + yyyy;
    return today;
  };

  useEffect(() => {
    profle();
  }, [pageNumber, limit, findByStatus]);

  if (user == undefined) {
    return null;
  }

  //date filter add

  function daterange(s, e) {
    if (s > e) {
      alert("Starting date is greater than ending date");
    } else {
      setStartDate(s);
      setEndDate(e);
    }
  }

  return (
    <>
      {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
      <div className="row ">
        <div className="col-12 grid-margin">
          <div className="card ">
            <div className="card-body text-light">
              <h4 className="card-title">Pending Deposit History</h4>

              {/* searching */}
              <div className="row">
                <div className="col-md-3">
                  <select
                    className="form-control col-sm-3 m-2"
                    id="searchType"
                    name="searchtype"
                    onChange={(e) => setSearchType(e.target.value)}
                  >
                    <option value="0">Select Search by</option>
                    <option value="Name">Name</option>
                    <option value="Phone">Phone</option>
                    <option value="_id">TxnId</option>
                    <option value="order_id">Order Id</option>
                    <option value="referenceId">UTR Number</option>
                    <option value="userUniqueId">Unique Id</option>
                    <option value="date">Date</option>
                  </select>
                </div>
                {searchType !== "date" ? (
                  <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control col-sm-4 m-2"
                      onChange={searchHandler}
                    />
                  </div>
                ) : (
                  ""
                )}
                {searchType === "date" ? (
                  <div className="col-md-6">
                    <div className="d-flex">
                      <div className="form-group mx-sm-3 mb-2">
                        <label htmlFor="startDate" className="sr-only">
                          Start Date
                        </label>
                        <input
                          type="datetime-local"
                          id=""
                          name=""
                          className="form-control"
                          value={startDate}
                          onChange={(e) => daterange(e.target.value, endDate)}
                        ></input>
                      </div>
                      <h5>To</h5>
                      <div className="form-group mx-sm-3 mb-2">
                        <label htmlFor="endDate" className="sr-only">
                          End Date
                        </label>
                        <input
                          type="datetime-local"
                          id=""
                          name=""
                          className="form-control"
                          value={endDate}
                          onChange={(e) => daterange(startDate, e.target.value)}
                        ></input>
                      </div>
                    </div>{" "}
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-1">
                  <button
                    className="btn btn-danger m-3"
                    onClick={() => profle()}
                  >
                    Submit
                  </button>
                </div>
                {searchType !== "date" ? (
                  <div className="col-md-3">
                    <select
                      className="form-control col-sm-3 m-2"
                      id="findByStatus"
                      name="findByStatus"
                      onChange={searchByStatus}
                    >
                      <option value="0">Search Status</option>
                      <option value="FAILED">FAILED</option>
                      <option value="Pending">Pending</option>
                      <option value="pending">pending</option>
                      <option value="PAID">PAID</option>
                      <option value="pending">pending</option>
                      <option value="checkin">Checkin</option>
                      <option value="slikpay">slikpay</option>
                      <option value="payin_upi">F2pay</option>
                      <option value="gateway">Cowpay</option>
                    </select>
                  </div>
                ) : (
                  ""
                )}
                {searchType !== "date" ? (
                  <div className="col-md-1 ms-auto">
                    <select
                      className="form-control col-sm-1 m-1 bg-dark text-light"
                      id="pagelimit"
                      name="pagelimit"
                      onChange={setpageLimit}
                    >
                      <option value="10">Set limit</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="500">500</option>
                    </select>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="table-responsive">
                <table className="table text-light">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th> ID</th>
                      <th> Payment Gateway Id</th>
                      <th> Phone</th>
                      <th> User</th>
                      <th> R_orderId</th>
                      <th> Amount </th>
                      <th> Status </th>
                      <th> ----- </th>
                      <th> Date </th>
                    </tr>
                  </thead>

                  <tbody>
                    {user &&
                      user.map((data, key) => {
                        var id = data._id.toString(),
                          ctr = 0;
                        var timestamp = id.slice(ctr, (ctr += 8));
                        var machineID = id.slice(ctr, (ctr += 6));
                        var processID = id.slice(ctr, (ctr += 4));
                        var counter = id.slice(ctr, (ctr += 6));
                        var counterid = parseInt(timestamp, 16);
                        let currentTime = Date.now();
                        let gameCreatedAt = new Date(data.createdAt).getTime();

                        return (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td>{data._id}</td>
                            <td>{data?.txn_id}</td>

                            <td>
                              {admindata?.user?.user_type == "Admin" ||
                              admindata?.user?.updateLegalData === true ? (
                                <span className="pl-2">
                                  {data.user ? data.user.Phone : ""}
                                </span>
                              ) : (
                                <span className="pl-2">{`${
                                  "********" +
                                  data.user.Phone.toString().slice(-2)
                                }`}</span>
                              )}
                            </td>
                            <td>
                              {data?.user || data?.user ? (
                                <Link
                                  className="btn btn-sm btn-outline-info"
                                  to={`/user/view_user/${
                                    findByStatus === "Pending"
                                      ? data?.user?._id
                                      : data?.user?._id
                                  }/0`}
                                >
                                  {findByStatus === "Pending"
                                    ? data?.user?.Name
                                    : data?.user?.Name}
                                </Link>
                              ) : (
                                ""
                              )}
                            </td>

                            <td>
                              {data.order_token}
                              <p>
                                client ip:{" "}
                                {data.client_ip ? data.client_ip : ""}{" "}
                              </p>
                            </td>
                            <td>{data.amount}</td>
                            <td className="font-weight-bold text-success">
                              {data.status}
                            </td>
                            <td style={{ minWidth: "260px" }}>
                              {
                                //&& data.status != 'FAILED'
                                data.status != "PAID" &&
                                data.status != "FAILED" &&
                                data.status != "ABORTED" &&
                                (parseInt(gameCreatedAt) +
                                  data.payment_gatway ==
                                "phonepe"
                                  ? 120000
                                  : 1800000) < currentTime ? (
                                  <>
                                    {data.type === "slikpay" && (
                                      <div className="border rounded p-2 bg-light mb-2">
                                        {/* UTR Input */}
                                        <input
                                          type="text"
                                          className="form-control d-inline w-50 mb-2"
                                          placeholder="Enter UTR"
                                          value={utrValue}
                                          onChange={(e) =>
                                            setUtrValue(e.target.value)
                                          }
                                        />

                                        <div className="d-flex gap-2">
                                          {/* 🔹 Button 1: Check via UTR */}
                                          <button
                                            className="btn btn-danger"
                                            disabled={!utrValue}
                                            onClick={() =>
                                              universalCheckDeposit(
                                                "utr-check-slikpay",
                                                utrValue,
                                                newdateFormat(data.createdAt),
                                              )
                                            }
                                          >
                                            Check via UTR
                                          </button>

                                          {/* 🔹 Button 2: Normal Slikpay Check */}
                                          <button
                                            className="btn btn-secondary"
                                            onClick={() =>
                                              universalCheckDeposit(
                                                "utr-final-check-slikpay",
                                                utrValue,
                                                newdateFormat(data.createdAt),
                                              )
                                            }
                                          >
                                            Check Utr Final
                                          </button>
                                        </div>
                                      </div>
                                    )}

                                    <button
                                      className="btn btn-danger"
                                      onClick={() =>
                                        universalCheckDeposit(
                                          data.type,
                                          data._id,
                                          newdateFormat(data.createdAt),
                                        )
                                      }
                                    >
                                      Check {data.type}
                                    </button>
                                  </>
                                ) : (
                                  "Checked All"
                                )
                              }

                              {
                                //   <button className="ml-1 btn btn-sm btn-warning" onClick={() => withdrowPass(data._id)}>Success</button>
                              }
                            </td>
                            <td>{dateFormat(data.createdAt).split(",")[0]} </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>

              <div className="mt-4">
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={numberOfPages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TempPending;
